import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { LatestService } from 'src/app/_models/latestService.model';
import { ToastrService } from 'ngx-toastr';
import { baseUrl, environment } from 'src/environments/environment';
import { showNotification } from 'src/app/helpers/show-toast';
import { LatestServicesService } from 'src/app/_services/latest-services.service';
import { DeleteModalComponent } from 'src/app/components/delete-modal/delete-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { sortTable } from 'src/app/helpers/sort-table';
import { ColumnSortingDirective } from 'src/app/_directives/column-sorting.directive';
import { IColumnSortEvent } from 'src/app/_interfaces/i-column-sort-event';

@Component({
  selector: 'app-latest-services-list',
  templateUrl: './latest-services-list.component.html',
  styleUrls: ['./latest-services-list.component.scss'],
})
export class LatestServicesListComponent implements OnInit {
  pageTitle: string = 'Latest Services';
  placeholder: string = 'Search by service name …';
  latestServicesArray: LatestService[] = [];
  filteredLatestServicesArray: LatestService[] = [];
  invertSort: boolean = false;
  theadArray = [
    'Service EN Name',
    'Service AR Name',
    'Service Rank',
    'Service Route',
    'Se7etak Service',
    'Latest Service',
    'Service Actions',
  ];
  modalRef: BsModalRef;
  @ViewChildren(ColumnSortingDirective)
  headers: QueryList<ColumnSortingDirective>;

  constructor(
    private latestService: LatestServicesService,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.getAllServices();
  }

  compare = (v1: string | number, v2: string | number) =>
    v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

  onSort({ column, direction }: IColumnSortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction == '' || column === '') {
      this.filteredLatestServicesArray = this.filteredLatestServicesArray;
    } else {
      this.filteredLatestServicesArray = [...this.filteredLatestServicesArray].sort(
        (a, b) => {
          const res = this.compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      );
    }
  }

  getAllServices() {
    this.latestService.getAllServices().subscribe((res) => {
      res?.data?.services.map((service) => {
        service.picture = `${service.picture}`;
        this.latestServicesArray.push(service);
      });

      this.filteredLatestServicesArray = [...this.latestServicesArray];
    });
  }

  onSearchService(searchString) {
    this.latestService.searchByName(searchString).subscribe((response) => {
      this.filteredLatestServicesArray = response['data']['services'];
    });
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredLatestServicesArray = [...this.latestServicesArray];
    }
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredLatestServicesArray = sortTable(
      this.filteredLatestServicesArray,
      'rank',
      this.invertSort
    );
  }

  onSehetakServiceChange(event, service) {
    service.typeId = event.target.checked ? 1 : 2;

    this.latestService.updateService(null, service).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.name} service has ${
          response.data.isActive
            ? 'been se7etak service'
            : 'not been se7etak service'
        }`,
        this.toastr
      );
    });
  }

  onLatestServiceChange(event, service) {
    service.statusId = event.target.checked ? 1 : 2;

    this.latestService.updateService(null, service).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.name} service has ${
          response.data.isActive
            ? 'been latest service'
            : 'not been latest service'
        }`,
        this.toastr
      );
    });
  }

  onDeleteService(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.enName,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteServiceSubmit(item.enName, data);
    });
  }

  onDeleteServiceSubmit(serviceName, serviceId) {
    this.latestService.deleteService(serviceId).subscribe((res) => {
      showNotification(
        'success',
        `${serviceName} has been deleted`,
        this.toastr
      );

      this.latestServicesArray = this.latestServicesArray.filter(
        (service) => service.id !== serviceId
      );

      this.filteredLatestServicesArray = [...this.latestServicesArray];

      this.modalRef.hide();
    });
  }
}
